import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconMinus = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-minus" data-icon="icon-minus" aria-hidden="true" {...props} ref={ref}><line x1="5" y1="12" x2="19" y2="12"/></svg>);
});

IconMinus.displayName = 'IconMinus';
